'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.numericTotaliser = function () {
	return mmWidgets.each(this, function () {
		const element = this,
			footer = element.find('tfoot tr'),
			recalculateColumn = function (column) {
				let total = 0;
				if (column === 0) {
					return;
				}
				element.find('tbody tr').domElements.forEach(function (domElement) {
					const row = mmWidgets(domElement),
						val = parseFloat(row.children().eq(column).text());
					if (!isNaN(val)) {
						total += val;
					}
				});
				footer.children().eq(column).text(total.toLocaleString());
			},
			initialTotal = function () {
				for (let column = 1; column < footer.children().length; column++) {
					recalculateColumn(column);
				}
			};
		element.on('change', function (evt /*, newValue*/) {
			const target = mmWidgets(evt.target);
			if (evt.column !== undefined) {
				recalculateColumn(evt.column);
			} else if (target.is('td')) {
				recalculateColumn(target.index());
			} else {
				initialTotal();
			}
		});
	});
};
